import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import BalanceForm from './BalanceForm';
import { FaPlusCircle } from 'react-icons/fa'; // Import the icon
import './BalanceChart.css'; // Create a CSS file for styling

const BalanceChart = ({ darkTheme }) => {
  const [data, setData] = useState([]);
  const [transactionKinds, setTransactionKinds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://coinflowapi-706a77649549.herokuapp.com/api/v1/balances', {
          headers: {
            Authorization: '4X2pKb5SWhC0fz3H5h8udkg59npyEmbe88xNoN5yE60utCAVeW5'
          }
        });
        console.log('Dados da API:', response.data);

        // Extrair todos os tipos de transaction_kind
        const kinds = Array.from(new Set(response.data.map(item => item.transaction_kind)));
        console.log('Tipos de transação detectados:', kinds);

        // Agrupar os dados por data
        const groupedData = response.data.reduce((acc, item) => {
          const date = new Date(item.due_date).toLocaleDateString('pt-BR'); // Ex: 28/01/2025

          if (!acc[date]) {
            acc[date] = { date }; // Inicializar a entrada para a data
            kinds.forEach(kind => (acc[date][kind] = 0)); // Inicializar cada tipo com 0
          }

          // Adicionar o valor ao tipo correspondente
          const amount = parseFloat(item.amount);
          if (!isNaN(amount)) {
            acc[date][item.transaction_kind] += amount;
          }

          return acc;
        }, {});

        console.log('Dados agrupados por dia:', groupedData);

        // Transformar os dados agrupados em um array
        const formattedData = Object.values(groupedData);

        console.log('Dados formatados para o gráfico:', formattedData);

        setTransactionKinds(kinds);
        setData(formattedData);
        setLoading(false);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <p>Carregando dados...</p>;
  }

  return (
    <div style={{ width: '100%', padding: '20px', backgroundColor: darkTheme ? '#222' : '#fff', color: darkTheme ? '#fff' : '#000' }}>
      <h1 style={{ textAlign: 'center', color: darkTheme ? '#fff' : '#000' }}>Gráfico de Lançamentos por Dia</h1>
      <div style={{ height: '400px', marginBottom: '20px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke={darkTheme ? '#444' : '#ccc'} />
            <XAxis
              dataKey="date"
              label={{ value: 'Dia', position: 'insideBottom', offset: -5, fill: darkTheme ? '#fff' : '#000' }}
              interval={0} // Exibir todas as datas presentes
              stroke={darkTheme ? '#fff' : '#000'}
            />
            <YAxis
              label={{ value: 'Valor', angle: -90, position: 'insideLeft', fill: darkTheme ? '#fff' : '#000' }}
              stroke={darkTheme ? '#fff' : '#000'}
            />
            <Tooltip contentStyle={{ backgroundColor: darkTheme ? '#333' : '#fff', border: `1px solid ${darkTheme ? '#444' : '#ccc'}`, color: darkTheme ? '#fff' : '#000' }} />
            <Legend wrapperStyle={{ color: darkTheme ? '#fff' : '#000' }} />
            {transactionKinds.map(kind => (
              <Line
                key={kind}
                type="monotone"
                dataKey={kind}
                stroke={getColor(kind)}
                name={kind}
                dot={{ r: 3 }}
                activeDot={{ r: 5 }}
                strokeWidth={3}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
      <button
        onClick={() => setShowForm(true)}
        className="add-button"
      >
        <FaPlusCircle className="add-icon" />
        Novo Lançamento
      </button>
      {showForm && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => setShowForm(false)}>&times;</span>
            <BalanceForm darkTheme={darkTheme} />
          </div>
        </div>
      )}
    </div>
  );
};

const getColor = kind => {
  const colors = {
    income: '#4caf50', // Verde para receitas
    expense: '#f44336', // Vermelho para despesas
    debt: '#2196f3',    // Azul para dívidas
  };
  return colors[kind] || '#000000'; // Preto como cor padrão
};

export default BalanceChart;
